export { AssistantWidget } from "./ui/AssistantWidget";
export { FixWithAssistantButton } from "./ui/FixWithAssistantButton";
export type { FixWithAssistantErrorCode } from "./ui/FixWithAssistantButton";
export { ASSISTANT_Z_INDEX } from "./ui/AssistantBubble";
export {
  openAssistant,
  closeAssistant,
  useAssistantPanelOpen,
} from "./model/assistantStore";
export type { AssistantStartInput } from "./model/assistantStore";
export { useAssistantAvailable } from "./model/useAssistantAvailable";
